import { Injectable, OnDestroy, inject } from '@angular/core';

import { MediaQueryService } from '@frontend/vanilla/core';
import { Observable, ReplaySubject, Subscription, distinctUntilChanged, map, of } from 'rxjs';

export enum StakeInputMode {
    Field = 1,
    Typing = 2,
}

export abstract class StakeInputModeStrategy {
    abstract get inputMode(): Observable<StakeInputMode>;
}

@Injectable({ providedIn: 'root' })
export class FieldStakeInputModeStrategy extends StakeInputModeStrategy {
    get inputMode(): Observable<StakeInputMode> {
        return of(StakeInputMode.Field);
    }
}

@Injectable({ providedIn: 'root' })
export class TypingStakeInputModeStrategy extends StakeInputModeStrategy {
    get inputMode(): Observable<StakeInputMode> {
        return of(StakeInputMode.Typing);
    }
}

@Injectable({ providedIn: 'root' })
export class DynamicInputModeStrategy extends StakeInputModeStrategy implements OnDestroy {
    private mediaService = inject(MediaQueryService);

    private subscription: Subscription;
    private subject$: ReplaySubject<StakeInputMode> = new ReplaySubject<StakeInputMode>();

    constructor() {
        super();

        this.subscription = this.mediaService
            .observe()
            .pipe(
                map(() => (this.mediaService.isActive('gt-md') ? StakeInputMode.Typing : StakeInputMode.Field)),
                distinctUntilChanged(),
            )
            .subscribe(this.subject$);
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    get inputMode(): Observable<StakeInputMode> {
        return this.subject$.asObservable();
    }
}
